import styled from 'styled-components';

const Label = styled.span`
  padding: ${props => props.theme.space(2)};
  border-radius: 2px;
  color: ${props => props.theme.labels.color};
  font-family: IntervalNextReg, sans-serif;
  font-weight: 600;
  font-size: ${props => props.theme.rem(14)};
  text-transform: capitalize;
`;

export const NewLabel = styled(Label)`
  background-color: ${props => props.theme.labels.newBackground};
`;

export const ExclusiveLabel = styled(Label)`
  background-color: ${props => props.theme.labels.exclusiveBackground};
`;

export const VerifiedLabel = styled(Label)`
  background-color: ${props => props.theme.labels.verifiedBackground};
`;

export const TrustedLabel = styled(Label)`
  background-color: ${props => props.theme.labels.trustedBackground};
`;

export const InstantBookingLabel = styled(Label)`
  background-color: ${props => props.theme.labels.instantBookingBackground};
`;

export const SoldOutLabel = styled(Label)`
  background-color: ${props => props.theme.labels.soldOutBackground};
`;

export const NewFilterLabel = styled(NewLabel)`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 600;
  font-size: ${props => props.theme.rem(12)};
  padding: ${props => props.theme.space()};
`;

export const NoDepositLabel = styled(Label)`
  background-color: ${props => props.theme.labels.noDepositBackground};
`;

export const UniplacesExclusiveLabel = styled(Label)`
  width: fit-content;
  height: 29px;
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.typography.invertedColor};
  background-color: ${props => props.theme.labels.uniplacesExclusive};
  padding-inline: 18px;
`;
